import { createBrowserRouter } from "react-router-dom";
import Layout from "./components/layout";
import AuthGuard from "./guards/AuthGuard";
import Organisation from "./pages/organisation";
import OrganisationGuard from "./guards/OrganisationGuard";
import ProjectsList from "./pages/projectsList";
import OrganisationDetails  from "./pages/organisation/OrganisationDetails";
import Verification from "./pages/authentication/verification";
import ForgotPassword from "./pages/authentication/forgot-password";
import ResetPassword from "./pages/authentication/forgot-password/reset-password";
import TaskViews from "./components/views/";
import Page404 from "./rootAuth/404page";
import ProjectDashboard from "./pages/dashboard/projectDashboard";
import ProjectMember from "./pages/project-details/projectMember";
import Terms from "./pages/terms/terms";
import PrivacyPolicy from "./pages/terms/privacyPolicy";
import MyTasks from "./pages/tasks/MyTask";
import ProjectDetails from "./pages/project-details/ProjectDetails";
import NewAccountSettings from "./pages/account-settings/NewAccount";
import NewLogin from "./pages/authentication/login/newLogin";
import NewSignup from "./pages/authentication/signup/newSignup";
import { PlanValidationProvider } from "@/context/paymentContext";
import CheckoutForm from "./pages/payment-checkout";
import RiskManagement from "./pages/risk-management";
import Scales from "./pages/risk-management/scales";
import PaymentPlans from "./components/PaymentPlans";
import ManagerDashboard from "./pages/dashboard/managerDashboard";
import ApiDocumentation from "./components/views/openApidocs";
import CollaboratorVerification from "./pages/authentication/verification/varifyCollaborator";
import WorkloadPlaning from "./pages/projectsList/workloadPlaning";

export const LayoutWithValidationProvider = () => (
  <PlanValidationProvider>
    <Layout />
  </PlanValidationProvider>
);
export const router = createBrowserRouter([
  {
    path: "/login",
    element: <NewLogin />,
  },
  {
    path: "/signup",
    element: <NewSignup />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/term-and-condition",
    element: <Terms />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/verify-email",
    element: <Verification />,
  },
  {
    path: "/collaborator/:userId",
    element: <CollaboratorVerification />,
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <LayoutWithValidationProvider />
      </AuthGuard>
    ),
    children: [
      {
        path: "/organisation",
        element: <Organisation />,
      },
      {
        path: "/",
        element: <ManagerDashboard />,
      },
      {
        path: "/projectDashboard/:projectId",
        element: <ProjectDashboard />,
      },
      {
        path: "/account-settings",
        element: <NewAccountSettings />,
      },
      {
        path: "/project-details/:id",
        element: <ProjectDetails />,
      },
      {
        path: "/checkout/:client_secret",
        element: <CheckoutForm />,
      },
      {
        path: "/organisation/:organisationId",
        element: <OrganisationDetails />,
      },
      {
        path: "/capacity-planning",
        element: <WorkloadPlaning />,
      },
      {
        path: "/plans",
        element: <PaymentPlans onClose={() => {}} />,
      },
      {
        path: "/",
        element: <OrganisationGuard />,
        children: [
          {
            path: "/projects",
            element: <ProjectsList />,
          },
          {
            path: "/tasks/:projectId",
            element: <TaskViews />,
          },
          {
            path: "/workload/:projectId",
            element: <TaskViews />,
          },
          {
            path: "/members/:projectId",
            element: <ProjectMember />,
          },
          {
            path: "/mytasks",
            element: <MyTasks />,
          },
          {
            path: "/risk/:projectId",
            element: <RiskManagement />,
          },
          {
            path: "/risk/scales",
            element: <Scales />,
          },
        ],
      },
    ],
  },
  {
    path: "docs",
    element: <ApiDocumentation />,
  },
  {
    path: "*",
    element: <Page404 />,
  },
]);
